import React, { useRef, useState, useEffect } from "react";
import { Editor } from "@tinymce/tinymce-react";
import axios from "axios";

import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";

import { useParams, NavLink } from "react-router-dom";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { authActions } from "../../store/auth";
import { campaignAction } from "../../store/campaign-store";
import { landingPageAction } from "../../store/landingpage-store";

import "./landing.css";
import { cuteToast } from "../UI/cute";

const EditLanding = () => {
  const [content, setContent] = useState(null);
  const ref = useRef();
  const dispatch = useDispatch();
  const { camp_id } = useParams();
  const { sendRequest } = useHttp();
  const history = useHistory();

  const editorRef = useRef(null);
  useEffect(() => {
    document.title = `${endPoints.title} | Edit Page`;
    dispatch(authActions.setLoaderStatus({ status: true }));
    dispatch(campaignAction.preState({ camp_id }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [camp_id]);
  const token = useSelector((state) => state.auth.token);

  // console.log(history.goBack());

  useEffect(() => {
    // console.log("Akash");

    sendRequest(
      {
        url: endPoints.fetchLandingPage + "/" + camp_id,
        body: "",
        method: "GET",
      },
      (response) => {
        if (response.status === 200) {
          if (response.body) {
            // redirect to edit landing page
            // console.log(response.body.content);
            dispatch(
              landingPageAction.setPagecontent({
                status: response.body.status,
                content: response.body.content,
              })
            );

            setContent(response.body.draft_content);
          } else {
            history.push("/select-landing/" + camp_id);
          }
        }

        // dispatch(landingPageAction.setPageLoad({ is_page_load: true }));
        dispatch(authActions.setLoaderStatus({ status: false }));
      }
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleSaveContent = (e, type) => {
    if (editorRef.current) {
      dispatch(authActions.setLoaderStatus({ status: true }));

      const newcontent = editorRef.current.getContent();
      setContent(newcontent);

      sendRequest(
        {
          url: endPoints.updateLandingpage,
          body: { camp_id, type, content: newcontent },
          method: "Post",
        },
        (response) => {
          if (response.status === 200) {
            cuteToast({
              type: "success",
              message: "",
              timer: 5000,
              title: "Successfully updated!",
            });
          }

          // dispatch(landingPageAction.setPageLoad({ is_page_load: true }));
          dispatch(authActions.setLoaderStatus({ status: false }));
        }
      );
    }
  };
  console.log(history);

  const goBack = () => {
    if (history.location.state !== undefined) {
      history.goBack();
    } else {
      history.push("/");
    }
  };
  return (
    <>
      <section className="mid_wrap">
        <div className="container">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb mb-4 pb-2">
              <li className="breadcrumb-item">
                <Link to="/">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Edit Landing Page
              </li>
            </ol>
          </nav>

          <div className="row">
            <div className="col-sm-6">
              <button className="btn" onClick={goBack}>
                Go Back
              </button>
            </div>
            <div className="col-sm-6">
              <div
                className="dropdown dropdownDiv pull-right"
                style={{ float: "right" }}
              >
                <NavLink
                  data-bs-toggle="collapse"
                  to="#landing-dropdown"
                  role="button"
                  aria-expanded="false"
                  aria-controls="landing-dropdown"
                  ref={ref}
                  className="publish_btn dropdown-toggle"
                >
                  <i className="fa fa-sort-down"></i>
                </NavLink>

                <ul
                  className="collapse dropdown-menu dropmenu"
                  id="landing-dropdown"
                >
                  <li>
                    <a
                      href={`https://www.vidconnect.net/page/${camp_id}`}
                      rel="noreferrer"
                      target="_blank"
                    >
                      Preview
                    </a>
                  </li>
                  {/* <li>
                    <a href="0#">Publish</a>
                  </li> */}
                </ul>
              </div>
              <button
                className="btn pull-right updatebtn"
                onClick={(e) => handleSaveContent(e, "content")}
              >
                Update & Publish
              </button>

              <button
                className="btn pull-right updatebtn savedraftbtn"
                onClick={(e) => handleSaveContent(e, "draft_content")}
              >
                Save As Draft
              </button>
            </div>
            <div className="col-md-12 mt-5" id="editorDiv">
              {content && (
                <Editor
                  apiKey="rbxflb7whlpznl4h5gug810a4d6fys81f88bohqmmqovz1dz"
                  onInit={(evt, editor) => (editorRef.current = editor)}
                  initialValue={content}
                  init={{
                    height: 500,
                    menubar: false,
                    plugins: [
                      "advlist autolink lists link charmap print preview anchor noneditable",
                      "searchreplace visualblocks code fullscreen",
                      "insertdatetime media table paste code help wordcount",
                      "image",
                      "media ",
                    ],
                    //   noneditable_editable_class: "mceNonEditable",
                    toolbar:
                      "undo redo | formatselect | " +
                      "forecolor |" +
                      "bold italic backcolor | alignleft aligncenter " +
                      "alignright alignjustify | bullist numlist outdent indent | image",

                    content_css: false,
                    inline: true,
                    file_picker_types: "file image media",
                    images_upload_handler: async function (
                      blobInfo,
                      success,
                      failure
                    ) {
                      // console.log(
                      //   blobInfo.blobUri(),
                      //   blobInfo.filename(),
                      //   blobInfo.name(),
                      //   blobInfo.uri()
                      // );
                      let imageFile = new FormData();
                      imageFile.append("file", blobInfo.blob());

                      try {
                        console.log(blobInfo.filename().split(".").pop());

                        const data = await axios.post(
                          process.env.REACT_APP_BASE_URL +
                            "campaigns/uploadImage",
                          imageFile,
                          {
                            headers: {
                              "Content-Type": "multipart/form-data",
                              Authorization: "Bearer " + token,
                            },
                          }
                        );
                        // console.log(data);
                        success(data.data.url);
                      } catch (error) {
                        // handleResponseError(error);
                        return;
                      }
                    },
                    // content_style: [cs].join('\n')
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default EditLanding;
